export { default as Header } from './header';
export { default as EnterpriseThankYouBody } from './body';
export { default as EnterpriseThankYouFooter } from './footer';
export { default as EnterpriseThankYouLayout } from './layout';
